<template>
  <div class="z-max">
    <q-dialog v-model="alert" persistent class="">
      <q-card class="hint">
        <div class="icon">
          <q-img src="~assets/icons/png/Upset.png" class="img-icon" alt="" />
        </div>
        <!-- 关于营业时间的提醒 -->
        <div v-if="statusCode === 100 || statusCode === 300" class="text">
          {{ $t('componentsErrorDialog.closeReason') }}
          <div
            v-if="statusCode === 100 && nextBusinessTime !== ''"
            class="text"
          >
            {{ $t('componentsErrorDialog.pleaseComeBack') }} <br />
            {{ nextBusinessTime }}
          </div>
        </div>
        <!-- 关于营业时间的提醒 END -->
        <div v-if="showVal === 'all'" class="text">
          {{ $t('componentsErrorDialog.storeReason1') }}
        </div>
        <div v-if="showVal === 'dineIn'" class="text">
          {{ $t('componentsErrorDialog.storeReason2') }}
        </div>
        <div v-if="showVal === 'pickUp'" class="text">
          {{ $t('componentsErrorDialog.storeReason3') }}
        </div>
        <q-btn
          v-if="showVal === 'pickUp'"
          class="btn"
          color="primary"
          :label="$t('componentsErrorDialog.changeToPickup')"
          @click="gotoCheckout('PICK_UP')"
        />
        <q-btn
          v-if="showVal === 'dineIn'"
          class="btn"
          color="primary"
          :label="$t('componentsErrorDialog.changeToDinein')"
          @click="gotoCheckout('DINE_IN')"
        />
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
const days = {
  Monday: 'Senin',
  Tuesday: 'Selasa',
  Wednesday: 'Rabu',
  Thursday: 'Kamis',
  Friday: 'Jumat',
  Saturday: 'Sabtu',
  Sunday: 'Minggu',
};

export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    showOneType: {
      type: String,
      default: '',
    },
    status: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      alert: false,
      showVal: '',
      statusCode: 200,
      nextBusinessTime: '',
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          const { status = {} } = val;
          const { statusCode = 200, nextBusinessTime = '' } = status;
          this.statusCode = statusCode;
          this.nextBusinessTime =
            nextBusinessTime !== null ? nextBusinessTime : '';

          // 营业时间逻辑
          if (statusCode !== 200) {
            this.alert = true;
            return;
          }

          if (
            val.dineIn === false &&
            val.pickUp === false &&
            val.delivery === false
          ) {
            this.showVal = 'all';
            this.alert = true;
          } else {
            this.alert = false;
          }
        }
      },
      immediate: true,
    },
    showOneType: {
      handler(val) {
        if (val) {
          this.showVal = val;
          this.alert = true;
        }
      },
    },
  },
  methods: {
    gotoCheckout(type) {
      const url = this.$route.params.store;
      // window.localStorage.setItem('serviceType', type);
      // const res = await setSessionCollectionMethod({ serviceType: type });
      this.$store.dispatch('Menu/resetSchedule');
      this.$store.commit('Menu/updateAccessStatus', type);
      if (this.$route.path.indexOf('checkout') > -1) {
        window.location.reload();
      } else {
        this.$router.push(`/${url}/checkout`);
      }
      this.alert = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.hint {
  padding: 36px 24px 24px 24px;
  .icon {
    display: flex;
    justify-content: center;
    .img-icon {
      width: 64px;
      height: 64px;
    }
  }
  .text {
    text-align: center;
    font-family: GothamOffice;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 120%;
    color: $black;
    margin-top: 24px;
  }
  .btn {
    text-transform: initial;
    width: 100%;
    margin-top: 24px;
  }
}
</style>
